import styled from 'styled-components';

export const FormWrapper = styled.div`
  width: 100%;
`;

export const Label = styled.label`
  display: block;
  font-size: 1.6rem;
  margin-bottom: 8px;
  min-height: 21px;
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  height: 35px;
  font-size: 1.4rem;
  color: #222247;
  border: 2px solid #f3f4f8;
  background-color: transparent;
  border-radius: 7px;
  padding: 0 8px;
  :disabled {
    border: none;
    background: #f3f4f8;
  }
`;
